export enum LoginReason
{
    None,
    UserLocked,
    UserInactive,
    PasswordExpired,
    CredentialFailure
};